// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__66E3F","filters_close":"FiltersBlock_filters_close__bdmn6"};